module.exports = __webpack_public_path__ + "img/figure.a679bb97.svg";